<style type="text/css">
  .SectionTableContainer:not(.section-resource--selected):hover .SectionTable--section-resource-actions-wrapper .SectionTable_column:not(.col-row-header, .col-left, .col-extra) {
    background-color: #fff4cbb8;
    /*background-color: #fff4cb;*/
  }

  .SectionTable {
    /*width: 100%;*/
    display: table;
    border-collapse: collapse;
    position: relative;
    /*background: #fff;*/
    table-layout: fixed;
  }
  .SectionTable.SectionTable--section-resource {
    cursor: pointer;
  }


  .SectionTable--section-resource-actions-wrapper {
    position: absolute;
  }

  .SectionTable--section-resource-actions {
    flex-direction: column;
    gap: 15px;
    position: absolute;
    top: 1px;
    /*right: -100px;*/
    right: 115px;
    z-index: 1;
  }

  .SectionTableContainer {
    background-color: #ffffff;
    /*box-sizing: border-box;*/
    /*border-right: 100px solid red;*/
    /*border-right: 100px solid transparent;    */
  }
  .SectionTableContainer:hover .SectionTable--section-resource-actions {
    position:absolute;
    display: flex;
  }

  .SectionTableContainer.just-added {
    transition: background-color 1000ms;
    background-color: #fee78fe0;
  }

  .SectionTableContainer.section-resource--selected {
    background-color: #eaf1ff;
  }

  .resource-selected-checkbox:not(.resource-selected-checkbox--visible) {
   /*opacity: 0.65;*/
  }

  .SectionTableContainer:hover .resource-selected-checkbox {
    opacity: 1;
  }

  .resource-selected-checkbox .v-input--selection-controls__input {
    margin: 0;
    i {
      color: #1976d2;
    }
  }

  .resource-selected-checkbox .v-input__slot {
    min-height: auto !important;
  }


  .resource-toolbar {
    padding: 7px 0;
    top: -8px;
    left: -1px;
    position:absolute;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 1;
  }
  .resource-toolbar:hover {
    left: -12px;
    z-index: 2;
  }
  .resource-toolbar .resource-toolbar--trigger {
    display: none;
  }

  .resource-toolbar .resource-toolbar--panel {
    display: flex;
    flex-direction: column;
    //display: none;
  }

  .resource-toolbar:hover .resource-toolbar--panel, .resource-toolbar:focus .resource-toolbar--panel {
    display: flex;
    flex-direction: column;
  }

  .resource-toolbar i ~ span  {
    display: none;
  }
  .resource-toolbar:hover i ~ span  {
    display: inherit;
  }

</style>

<template>

  <div
    :id="('section-resource-' + resource.id)"
    class="SectionTableContainer"
    :class="resource.isSelected && 'section-resource--selected'"
    style="position: relative;"
    :title="translate('ui_dialog_edit')"
  >
    <div
      v-if="allowDelete || allowClone"
      class="resource-toolbar"
    >
      <v-checkbox
        v-if="shouldShowResourceSelector"
        v-model="resource.isSelected"
        label=""
        style="margin: 0; padding: 0;"
        hide-details
        :title="translate('ui_select_btn')"
        :class="resource.isSelected && 'resource-selected-checkbox--visible'"
        class="resource-selected-checkbox"
      ></v-checkbox>

      <div class="resource-toolbar--panel">
        <v-btn
          v-if="allowClone"
          x-small
          @click="cloneResource"
          text
          :title="translate('ui_clone_btn')"
          min-width="22"
          style="padding: 3px 2px; height: auto;"
          color="teal"
          data-testid="resource-toolbar__btn-clone-resource"
        >
          <v-icon style="font-size: 13px;">mdi-content-copy</v-icon>
          <span style="font-size: 8px; line-height: 9px; text-decoration: underline;">{{ translate('ui_clone_btn') }}</span>
        </v-btn>

        <v-btn
          v-if="allowDelete"
          x-small
          @click="deleteSectionResource"
          text
          :title="translate('ui_delete_btn')"
          min-width="22"
          style="margin-top: 10px; padding: 3px 2px; height: auto;"
          color="red"
          data-testid="resource-toolbar__btn-delete-resource"
        >
          <v-icon style="font-size: 13px;">mdi-close</v-icon>
          <span style="font-size: 8px; line-height: 9px; text-decoration: underline;">{{ translate('ui_delete_btn') }}</span>
        </v-btn>

        <v-btn
          v-if="allowMove"
          x-small
          @click="moveResource"
          text
          :title="translate('ui_move_to_cos_btn')"
          min-width="22"
          style="margin-top: 10px; padding: 3px 2px; height: auto;"
          color="red"
          data-testid="resource-toolbar__btn-move-resource"
        >
          <template v-if="resource.coreResource.rel === 'cos'" >
            <v-icon style="font-size: 13px;">mdi-arrow-down</v-icon>
            <span style="font-size: 8px; line-height: 9px; text-decoration: underline;">{{ translate('ui_move_to_sga_btn') }}</span>
          </template>
          <template v-if="resource.coreResource.rel === 'sga'" >
            <v-icon style="font-size: 13px;">mdi-arrow-up</v-icon>
            <span style="font-size: 8px; line-height: 9px; text-decoration: underline;">{{ translate('ui_move_to_cos_btn') }}</span>
          </template>
        </v-btn>
      </div>
    </div>

    <div v-if="!resource.isEdited">
<!--      <div class="SectionTable SectionTable&#45;&#45;section-resource-actions-wrapper" style="width: calc(100% + 100px);">-->
      <div class="SectionTable SectionTable--section-resource-actions-wrapper">
        <div>
          <TemplateSectionResourceTableRow
            v-for="(row, i) in rowsHighlightableColumns"
            :key="i"
            :row="row"
            :hideExtraColumns=true
          />
        </div>
      </div>

      <div
        class="SectionTable SectionTable--section-resource"
        @click="this.editSectionResource"
      >
        <TemplateSectionResourceTableRow
          v-for="(row, i) in rows"
          :key="i"
          :row="row"
        />
        <TemplateSectionResourceTableRow emptyRow/>
      </div>
    </div>
    <div v-if="resource.isEdited" style="position: relative; overflow: hidden;">
      <TemplateSectionJaggedBorderTop/>
      <TemplateSectionBackground/>
      <DialogResourceAdd
        ref="dialogResourceAdd"
        :section="section"
        :resource="clonedResource"
        @onCloseDialogResourceAdd="onCloseDialogResourceAdd"
      />

      <div class="SectionTable">
        <TemplateSectionJaggedBorderBottom/>
        <TemplateSectionResourceTableRow emptyRow/>
      </div>
    </div>

  </div>

</template>

<script>

import TemplateSectionBackground
  from '@/components/sections/TemplateSection/TemplateSectionBackground';
import DialogResourceAdd from '@/components/dialogs/DialogResourceAdd';
import TemplateSectionJaggedBorderTop
  from '@/components/sections/TemplateSection/TemplateSectionJaggedBorderTop';
import TemplateSectionJaggedBorderBottom
  from '@/components/sections/TemplateSection/TemplateSectionJaggedBorderBottom';
import TemplateSectionResourceTableRow from './TemplateSectionResourceTableRow.vue';

// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {
    TemplateSectionJaggedBorderTop,
    TemplateSectionJaggedBorderBottom,
    TemplateSectionBackground,
    DialogResourceAdd,
    TemplateSectionResourceTableRow,
  },
  mixins: [Mixin],
  props: {
    section: Object,
    resource: Object,
    showResourceSelector: Boolean,
  },
  data: () => ({
    dialogConfig: {
      title: 'Edit',
      formulas: [],
      section: null,
      resource: null,
      onScrollDisabled: false,
    },
    dialogSimpleConfig: {
      title: 'Edit',
      formulas: [],
      section: null,
      resource: null,
    },
    dialogFormula: {},
    dialogAssumptions: [],
    dialogUnits: [],
    clonedResource: {},
  }),
  computed: {
    allowMove() {
      return ['cos', 'sga'].includes(this.resource.coreResource.rel);
    },
    shouldShowResourceSelector() {
      return false;
      // return this.section.isEditingSettings;
    },
    editResourceDialogSimpleVisible: {
      get() {
        return this.$store.state.dialogs.editResourceDialogSimpleVisible;
      },
      set(value) {
        this.$store.commit('updateState', {
          path: 'dialogs.editResourceDialogSimpleVisible',
          value,
        });
      },
    },
    editResourceDialogVisible: {
      get() {
        return this.$store.state.dialogs.editResourceDialogVisible;
      },
      set(value) {
        this.$store.commit('updateState', {
          path: 'dialogs.editResourceDialogVisible',
          value,
        });
      },
    },
    allowClone() {
      // return false;
      return !this.resource.coreResource.isDefault;
    },
    allowDelete() {
      return !this.resource.coreResource.isDefault;
    },
    rowsHighlightableColumns() {
      const { activeTemplate } = this.$store.state;
      const rows = [];

      rows.push({});

      // skip for base currency
      if (this.resource.coreResource.rel !== 'currency') {
        this.resource.flows.forEach((flow) => {
          if (this.resource.flows.length > 1) {
            rows.push({});
            rows.push({});
          }

          // flow.formula.inputVariables.forEach((inputVariable, index) => {
          //   const variable = flow.formula.variables.find((v) => v.id === inputVariable.id);
          flow.formula.variables.forEach((variable) => {
            if (!variable.reference) {
              const fcst = [];
              const dateCount = activeTemplate.layout.cFcstColCount;
              // eslint-disable-next-line
              for (let i = 0; i < dateCount; i++) {
                fcst.push({});
              }
              rows.push({});
            }
          });
        });
      } else {
        const dateCount = activeTemplate.layout.cFcstColCount;
        rows[0].fcst = [];
        // eslint-disable-next-line
        for (let i = 0; i < dateCount; i++) {
          // rows[0].fcst.push('-');
        }
      }


      // other assumptions
      // eslint-disable-next-line
      if (this.resource.otherAssumptions) {
        Object.keys(this.resource.otherAssumptions).forEach((key) => {
          if (this.resource.otherAssumptions[key]) {
            const map = {
              service: ['accountsReceivablePeriod', 'inventoryPeriod', 'accountsPayablePeriod'],
              sga: ['accountsReceivablePeriod', 'inventoryPeriod', 'accountsPayablePeriod'],
              equity: ['dividend', 'commitment'],
              loan: ['interestmargin', 'commitment'],
              fixedasset: ['deprgroup', 'taxproperty'],
            };

            if (!map[this.resource.coreResource.rel]) {
              return;
            }

            const isAllowed = map[this.resource.coreResource.rel].includes(key);
            if (isAllowed && this.resource.coreResource.rel === 'equity') {
              rows.push({});
            } else if (isAllowed && this.resource.coreResource.rel === 'fixedasset') {
              const { lookupId } = this.resource.otherAssumptions[key];
              if (lookupId) {
                console.log(key);
                // eslint-disable-next-line
                const sectionResource = activeTemplate.data.env.sectionResources.find((sr) => sr.id === lookupId);

                if (sectionResource) {
                  rows.push({});
                } else {
                  console.error('no sectionResource for lookupId');
                }
              } else {
                console.warn(`no lookupId for ${key}`);
              }
            }
          }
        });
      }

      // one extra row for totals
      rows.push({});

      return rows;
    },
    rows() {
      const { activeTemplate } = this.$store.state;
      const rows = [];

      rows.push({ className: 'row-resource inputIndent0', content: this.resource.coreResource.name });

      // skip for base currency
      if (this.resource.coreResource.rel !== 'currency') {
        this.resource.flows.forEach((flow) => {
          const dateCount = activeTemplate.layout.cFcstColCount;
          if (this.resource.flows.length > 1) {
            // this is a financing
            rows.push({});
            const fcst = [];
            if (flow.formula.id === 'autodrawdownloan' || flow.formula.id === 'autodrawdown' || flow.formula.id === 'autorepaymentloan') {
              // eslint-disable-next-line
              for (let i = 0; i < dateCount; i++) {
                fcst.push(this.translate('ui_section_financing__auto'));
              }
            }

            rows.push({
              content: flow.id === 'incCash' ? 'ui_assumptions_findraw' : 'ui_assumptions_finrepay',
              className: 'contentIndent0bold',
              fcst,
            });

            // display here otherAssumptions commitment if present after drawdown section
            if (flow.id === 'incCash' && this.resource.otherAssumptions.commitment) {
              // eslint-disable-next-line
              const fcst = [];
              const { name, units, value } = this.resource.otherAssumptions.commitment;
              const fcstTemp = value ? value.split(';') : [];
              // eslint-disable-next-line
              for (let i = 0; i < dateCount; i++) {
                fcst.push(fcstTemp[i] || fcstTemp[fcstTemp.length - 1]);
              }
              // console.log(fcst);
              rows.push({ content: name, units, fcst });
            }
          }

          // flow.formula.inputVariables.forEach((inputVariable, index) => {
          //   const variable = flow.formula.variables.find((v) => v.id === inputVariable.id);
          flow.formula.variables.forEach((variable, index) => {
            if (!variable.reference) {
              const fcst = [];
              const fcstTemp = flow.fcst[index].scenarios[0].data ? flow.fcst[index].scenarios[0].data.split(';') : [flow.fcst[index].scenarios[0].data];
              // eslint-disable-next-line
              for (let i = 0; i < dateCount; i++) {
                fcst.push(fcstTemp[i] || fcstTemp[fcstTemp.length - 1]);
              }

              let units;
              if (variable.isCurrency) {
                // units will be a reference to currency coreResource
                units = flow.fcst[index].scenarios[0].units.name;
              } else {
                units = flow.fcst[index].scenarios[0].units;
              }
              // console.dir(flow.fcst[index].scenarios[0]);
              rows.push({
                className: `${variable.id} inputIndent1`, content: variable.name, units, fcst,
              });
            }
          });

          // show totals
          const { formula } = flow;
          if (formula.expression) {
            const formulaExpressionFcst = [];
            for (let i = 0; i < dateCount; i++) {
              let expression = formula.expression.split('=')[1].trim();
              // console.log(expression);
              let operands = expression.split(/[()=+\-*/]+/);
              // clean up operands
              // eslint-disable-next-line
              operands = operands.reduce((arr, operand) => {
                // eslint-disable-next-line
                operand = operand.trim();
                // eslint-disable-next-line
                const isNotNumber = isNaN(operand);
                const isNotEmptyString = operand.length;
                const isInArray = arr.includes(operand);
                if (isNotNumber && isNotEmptyString && !isInArray) {
                  arr.push(operand);
                }
                return arr;
              }, []);
              let variableIndex = 0;
              operands.forEach((operand) => {
                // console.log(operand);
                if (formula.variables[variableIndex]) {
                  const dataArr = flow.fcst[variableIndex].scenarios[0].data ? flow.fcst[variableIndex].scenarios[0].data.split(';') : '0';
                  const value = dataArr[i] || dataArr[dataArr.length - 1];
                  expression = expression.replace(new RegExp(operand, 'g'), value);
                  variableIndex++;
                }
              });
              // console.log(formula);
              // console.log(expression);
              try {
                // eslint-disable-next-line
                formulaExpressionFcst.push(eval(expression));
              } catch (e) {
                formulaExpressionFcst.push('#NULL!');
                console.log(`...error evaluating formual ${expression}`);
              }
              // formulaExpressionFcst.push(expression);
            }
            rows.push({
              className: 'contentIndent0bold',
              content: this.translate(flow.formula.subject.header),
              units: flow.fcst[0].scenarios[0].units.name,
              fcst: formulaExpressionFcst,
            });
          }
        });
      } else {
        const dateCount = activeTemplate.layout.cFcstColCount;
        rows[0].fcst = [];
        // eslint-disable-next-line
        for (let i = 0; i < dateCount; i++) {
          // rows[0].fcst.push('-');
        }
      }


      // other assumptions
      // eslint-disable-next-line
      if (this.resource.otherAssumptions) {
        Object.keys(this.resource.otherAssumptions).forEach((key) => {
          if (this.resource.otherAssumptions[key]) {
            const map = {
              service: ['accountsReceivablePeriod', 'inventoryPeriod', 'accountsPayablePeriod'],
              sga: ['accountsReceivablePeriod', 'inventoryPeriod', 'accountsPayablePeriod'],
              equity: ['dividend'],
              loan: ['interestmargin'],
              fixedasset: ['deprgroup', 'taxproperty'],
            };

            if (!map[this.resource.coreResource.rel]) {
              return;
            }

            const isAllowed = map[this.resource.coreResource.rel].includes(key);
            if (isAllowed && (this.resource.coreResource.rel === 'equity' || this.resource.coreResource.rel === 'loan')) {
              const { name, units, value } = this.resource.otherAssumptions[key];
              const fcst = [];
              const fcstTemp = value ? value.split(';') : [];

              const dateCount = activeTemplate.layout.cFcstColCount;
              // eslint-disable-next-line
              for (let i = 0; i < dateCount; i++) {
                fcst.push(fcstTemp[i] || fcstTemp[fcstTemp.length - 1]);
              }

              rows.push({ content: name, units, fcst });
            } else if (isAllowed && this.resource.coreResource.rel === 'fixedasset') {
              const { lookupId } = this.resource.otherAssumptions[key];
              if (lookupId) {
                console.log(key);
                // eslint-disable-next-line
                const sectionResource = activeTemplate.data.env.sectionResources.find((sr) => sr.id === lookupId);

                if (sectionResource) {
                  const { name, units } = sectionResource.coreResource;
                  const value = sectionResource.flows[0].fcst[0].scenarios[0].data;
                  console.log(`depr: ${value}`);
                  const fcst = [];
                  const fcstTemp = value ? value.split(';') : [];

                  const dateCount = activeTemplate.layout.cFcstColCount;
                  // eslint-disable-next-line
                  for (let i = 0; i < dateCount; i++) {
                    fcst.push(fcstTemp[i] || fcstTemp[fcstTemp.length - 1]);
                  }

                  // console.log(units);
                  // console.log(100);
                  // console.dir(sectionResource);
                  rows.push({ content: name, units, fcst });
                } else {
                  console.error('no sectionResource for lookupId');
                }
              } else {
                console.warn(`no lookupId for ${key}`);
              }
            }
          }
        });
      }

      return rows;
    },
  },
  methods: {
    moveResource(event) {
      event.preventDefault();
      this.moveSectionResource(this.resource);
    },
    toggleToolbar(event) {
      console.log(event);
    },
    cloneResource(event) {
      if (event) {
        event.preventDefault();
      }

      // reset dialog data
      this.dialogAssumptions = [];

      const newSectionResource = this.createNewSectionResource(this.section, this.resource.coreResource.rel);
      newSectionResource.coreResource.name = this.resource.coreResource.name;
      newSectionResource.flows[0].formula = this.resource.flows[0].formula;
      newSectionResource.flows[0].fcst = JSON.parse(JSON.stringify(this.resource.flows[0].fcst));

      this.saveResource({
        resource: newSectionResource,
        position: {
          afterResource: this.resource,
        },
      });
      // update preview
      this.$store.dispatch('saveRemoteTemplate');
    },
    selectFirstInput(param) {
      const that = this;
      let inputToSelect;
      if (typeof param === 'object') {
        inputToSelect = param;
      }
      setTimeout(() => {
        if (!inputToSelect) {
          // eslint-disable-next-line
          const currentDialogElement = that.$refs.dialogResourceAdd.$el;
          if (currentDialogElement) {
            // scroll dialog to the top
            currentDialogElement.scrollTop = 0;
            inputToSelect = currentDialogElement.querySelector('input[type="text"]');
          // } else {
          //   // editing section
          //   const sectionId = param;
          //   inputToSelect = document.querySelector(`#${sectionId} input[type="text"]`);
          }
        }
        // don't autofocus if on small screen
        if (document.documentElement.clientWidth > 600 && inputToSelect) {
          inputToSelect.focus();
          inputToSelect.select();
        }
      }, 100);
    },
    onCloseDialogResourceAdd() {
      // eslint-disable-next-line
      this.resource.isEdited = false;
      this.clonedResource = {};
    },
    editResource(event, section, resource) {
      event.preventDefault();
      // reset dialog data
      this.dialogAssumptions = [];

      // const { formulas } = this.$store.state.activeTemplate.data;
      const formulas = this.getFormulas(resource);
      // eslint-disable-next-line
      const units = resource.flows[0].fcst.map((fcst) => {
        return fcst.scenarios[0].units;
      });

      // get currencies
      const sectionMacro = this.$store.state.activeTemplate.data.sections[2];
      const sectionCurrencies = sectionMacro.sections[0];
      const currencies = sectionCurrencies.sectionResources
        .map((sr) => sr.coreResource.name);

      const title = `${this.translate('ui_dialog_edit')} ${resource.coreResource.name}`;
      const config = {
        title,
        formulas,
        resource,
        section,
        // sectionComponent,
        units,
        initialStep: 2, // section.id === 'section_financing' ? 2 : 1,
        currencies,
      };


      // eslint-disable-next-line
      this.dialogFormula = formulas[0];

      // eslint-disable-next-line
      this.dialogAssumptions = resource.flows[0].fcst.map((fcst) => {
        return fcst.scenarios[0].data;
      });

      const simpleDialog = section.id === 'section_currency'
        || section.id === 'section_taxes' || section.id === 'section_depreciation';

      if (simpleDialog) {
        this.dialogConfig = config;
        this.$store.commit('updateState', {
          path: 'dialogs.editResourceDialogSimpleVisible',
          value: true,
        });
      } else {
        this.dialogConfig = config;
        this.$store.commit('updateState', {
          path: 'dialogs.editResourceDialogVisible',
          value: true,
        });
      }

      this.selectFirstInput();
    },
    deleteSectionResource(event) {
      event.preventDefault();
      event.stopPropagation();
      this.deleteResource(null, this.resource);
      this.$store.dispatch('saveRemoteTemplate');
      // const confirm = window.confirm(this.translate('ui_confirm_delete'));
      // if (confirm) {
      //   this.deleteResource(event, this.resource);
      // }
    },
    editSectionResource() {
      this.cacheScrollPosition();
      // shows up dialog
      this.updateIsEditingResource(this.resource, true);
      // this.$emit('updateIsEditingResource', this.resource, true);
      // this.resource.isEdited = true;
      this.clonedResource = JSON.parse(JSON.stringify(this.resource));
      // TODO: move this into the dialog
      this.selectFirstInput();
      const elementIdToScrollTo = `section-resource-${this.resource.id}`;
      this.scrollToDialog(elementIdToScrollTo);
    },
    cloneSectionResource(event) {
      if (event) {
        event.preventDefault();
      }

      // reset dialog data
      this.dialogAssumptions = [];

      const newSectionResource = this.createNewSectionResource(this.section, this.resource.coreResource.rel);
      newSectionResource.coreResource.name = this.resource.coreResource.name;
      newSectionResource.flows[0].formula = this.resource.flows[0].formula;
      newSectionResource.flows[0].fcst = JSON.parse(JSON.stringify(this.resource.flows[0].fcst));

      const formulas = this.getFormulas(newSectionResource);
      // eslint-disable-next-line
      // const units = newSectionResource.flows[0].fcst.map((fcst) => {
      //   return fcst.scenarios[0].units;
      // });

      const title = `${this.resource.coreResource.name}`;

      const config = {
        title,
        formulas,
        resource: newSectionResource,
        section: this.section,
        // units,
        initialStep: 2, // resource.coreResource.rel ? 2 : 1,
      };
      this.dialogConfig = config;
      // this.$store.commit('updateState', {
      //   path: 'dialogs.editResourceDialogVisible',
      //   value: true,
      // });

      // this.$store.commit('updateState', {
      //   path: 'dialogs.editResourceDialogVisible',
      //   value: true,
      // });

      this.selectFirstInput();
    },
  },
  mounted() {},
  updated() {},
};
</script>
